import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { GetAuditRequest } from "@/main/models/request";
import { GetAuditResponse } from "@/main/models/response";

export abstract class IProcurementParameterAuditApi {
	abstract getParameterAudit(request: GetAuditRequest): Promise<AxiosResponse<Result<GetAuditResponse[]>>>;
}
